<template>
  <div v-frag class="prism-elite-app">
    <CardIeaAppMain colorCard="#0F172A" title="">
      <v-col cols="12" class="pa-0 main-container-glass">
        <!-- Top Bar / Navigation -->
        <div class="prism-top-bar d-flex align-center justify-space-between px-8 py-5">
           <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({ name: 'Home' })"
              class="mr-4 glass-btn"
              large
            >
              <v-icon color="primary">mdi-arrow-left-circle-outline</v-icon>
            </v-btn>
             <div>
              <h1 class="text-h6 font-weight-black prism-title mb-0">Sistema de Consultas</h1>
              <div class="text-caption grey--text font-weight-medium">Soporte Académico y Administrativo</div>
            </div>
           </div>
        </div>

        <v-divider class="prism-divider"></v-divider>

        <v-row class="pa-8">
          <!-- Left Column: New Request -->
          <v-col cols="12" lg="5">
            <v-card flat class="pa-8 rounded-xl glass-card-heavy sticky-card mb-6">
              <div class="d-flex align-center mb-8">
                 <div class="elite-icon-box mr-4">
                    <v-icon color="primary">mdi-message-plus-outline</v-icon>
                 </div>
                 <div>
                    <h2 class="text-h5 font-weight-black prism-heading">Nueva Solicitud</h2>
                    <p class="text-caption grey--text mb-0">Nuestro equipo responderá a la brevedad.</p>
                 </div>
              </div>

              <div class="prism-form">
                <div class="text-overline font-weight-black mb-2 primary--text">Asunto de la consulta</div>
                <v-text-field
                  v-model="titulo"
                  placeholder="Ej: Duda sobre el módulo 3 o Error en pago"
                  outlined
                  flat
                  class="rounded-xl elite-input mb-4"
                  hide-details
                ></v-text-field>

                <div class="text-overline font-weight-black mb-2 primary--text">Descripción detallada</div>
                <v-textarea
                  v-model="descripcion"
                  placeholder="Por favor, sea lo más específico posible para brindarle una mejor solución..."
                  outlined
                  flat
                  rows="5"
                  class="rounded-xl elite-textarea mb-6"
                   hide-details
                ></v-textarea>

                <div class="text-overline font-weight-black mb-2 primary--text">Documentación de Respaldo</div>
                <v-file-input
                  v-model="files"
                  multiple
                  outlined
                   flat
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                  label="Adjuntar imágenes o documentos"
                  class="rounded-xl elite-input mb-8"
                  hide-details
                >
                  <template v-slot:selection="{ text }">
                    <v-chip small label color="primary" class="rounded-lg mr-1">{{ text }}</v-chip>
                  </template>
                </v-file-input>

                <v-btn
                  block
                  color="primary"
                  x-large
                  depressed
                  class="rounded-xl font-weight-black letter-spaced"
                  @click="addConsulta()"
                >
                  ENVIAR CONSULTA PROFESIONAL
                </v-btn>
              </div>
            </v-card>
          </v-col>

          <!-- Right Column: History -->
          <v-col cols="12" lg="7">
            <div class="consultas-viewport">
               <!-- Section: General Inquiries -->
               <div class="mb-10">
                  <div class="d-flex align-center justify-space-between mb-6">
                    <h2 class="text-h5 font-weight-black prism-heading">Mis consultas generales</h2>
                    <v-chip small color="primary" outlined>{{ consultas.length }}</v-chip>
                  </div>

                  <div v-if="!consultas.length" class="text-center py-10 glass-card-light rounded-xl mb-6">
                    <v-icon color="grey lighten-3">mdi-message-outline</v-icon>
                    <div class="text-caption grey--text mt-2 font-weight-medium">No hay consultas generales registradas.</div>
                  </div>

                  <div v-for="c in consultas" :key="'g-'+c.id" class="mb-4">
                    <v-card flat class="rounded-xl glass-card-interactive overflow-hidden">
                       <div class="pa-6">
                          <div class="d-flex justify-space-between align-start mb-4">
                              <div class="d-flex align-center">
                                 <v-avatar size="40" color="primary lighten-5" class="mr-3">
                                    <v-icon color="primary" small>mdi-chat-processing-outline</v-icon>
                                 </v-avatar>
                                 <div class="text-h6 font-weight-black mb-0">{{ c.titulo }}</div>
                              </div>
                              <v-chip
                                x-small
                                :color="c.ConsultaGeneralesRespuesta ? 'success' : 'warning'"
                                class="font-weight-black"
                                dark
                              >
                                {{ c.ConsultaGeneralesRespuesta ? 'RESPONDIDO' : 'EN ESPERA' }}
                              </v-chip>
                          </div>
                          <div class="text-body-2 grey--text text--darken-3 mb-6 bg-slate-50 pa-4 rounded-lg border-s">
                             {{ c.descripcion }}
                          </div>
                          <div v-if="c.ConsultaGeneralesRespuesta" class="elite-response-box pa-6 rounded-xl">
                              <div class="d-flex align-center mb-3">
                                 <v-icon color="success" size="18" class="mr-2">mdi-check-decagram</v-icon>
                                 <span class="text-caption font-weight-black success--text uppercase">Respuesta Oficial</span>
                              </div>
                              <div class="text-body-2 mb-4 font-weight-medium">{{ c.ConsultaGeneralesRespuesta.respuesta }}</div>
                              <div class="d-flex align-center justify-space-between pt-4 border-top">
                                 <div class="text-tiny grey--text font-weight-bold">Soporte IEA: <span class="primary--text">{{ c.usu_nombre || 'IEA Helpdesk' }}</span></div>
                                 <star-rating 
                                   v-model="c.puntaje" 
                                   @rating-selected="calificar($event, c.id, 'G')" 
                                   :increment="1" :max-rating="5" 
                                   inactive-color="#e2e8f0" active-color="#fbbf24" 
                                   :star-size="18" :read-only="c.tiene_puntuacion === 'S'" :show-rating="false"
                                 />
                              </div>
                          </div>
                       </div>
                    </v-card>
                  </div>
               </div>

               <!-- Section: Payment Inquiries -->
               <div>
                  <div class="d-flex align-center justify-space-between mb-6">
                    <h2 class="text-h5 font-weight-black prism-heading">Mis Informes de Pagos</h2>
                    <v-chip small color="success" outlined>{{ consultasAcreditacion.length }}</v-chip>
                  </div>

                  <div v-if="!consultasAcreditacion.length" class="text-center py-10 glass-card-light rounded-xl">
                    <v-icon color="grey lighten-3">mdi-cash-remove</v-icon>
                    <div class="text-caption grey--text mt-2 font-weight-medium">No se registran informes de pago.</div>
                  </div>

                  <div v-for="ca in consultasAcreditacion" :key="'a-'+ca.id" class="mb-4">
                    <v-card flat class="rounded-xl glass-card-interactive overflow-hidden border-accent">
                       <div class="pa-6">
                          <div class="d-flex justify-space-between align-start mb-4">
                              <div class="d-flex align-center">
                                 <v-avatar size="40" color="success lighten-5" class="mr-3">
                                    <v-icon color="success" small>mdi-cash-check</v-icon>
                                 </v-avatar>
                                 <div class="text-h6 font-weight-black mb-0">{{ ca.titulo }}</div>
                              </div>
                              <v-chip
                                x-small
                                :color="ca.ConsultaAcreditacionRespuesta ? 'success' : 'warning'"
                                class="font-weight-black"
                                dark
                              >
                                {{ ca.ConsultaAcreditacionRespuesta ? 'ACREDITADO' : 'PENDIENTE' }}
                              </v-chip>
                          </div>
                          <div v-if="ca.ConsultaAcreditacionRespuesta" class="elite-response-box accred rounded-xl">
                             <div class="pa-6">
                                <div class="d-flex align-center mb-3">
                                   <v-icon color="success" size="18" class="mr-2">mdi-check-circle</v-icon>
                                   <span class="text-caption font-weight-black success--text uppercase">Estado de Acreditación</span>
                                </div>
                                <div class="text-body-2 mb-4 font-weight-medium">{{ ca.ConsultaAcreditacionRespuesta.respuesta }}</div>
                                <div class="d-flex align-center justify-space-between pt-4 border-top">
                                   <div class="text-tiny grey--text font-weight-bold">Tesorería: <span class="success--text">{{ ca.usu_nombre || 'Oficina de Pagos' }}</span></div>
                                   <star-rating 
                                     v-model="ca.puntaje" 
                                     @rating-selected="calificar($event, ca.id, 'A')" 
                                     :increment="1" :max-rating="5" 
                                     inactive-color="#e2e8f0" active-color="#fbbf24" 
                                     :star-size="18" :read-only="ca.tiene_puntuacion === 'S'" :show-rating="false"
                                   />
                                </div>
                             </div>
                          </div>
                       </div>
                    </v-card>
                  </div>
               </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>


<script>
import StarRating from 'vue-star-rating'
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Consulta",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    StarRating
  },

  data: () => ({
    title:"Nueva consulta",
    dialog_desc: [],
    dialog: [],
    dialog_acred: [],
    titulo: '',
    descripcion: '',
    consultas:[],
    consultasAcreditacion:[],
    files:[],
    respuestaAcreditacion : '',
    rating:3
  }),

  methods: {

    async calificar(puntaje,idConsulta,tipo){
      let url = "consultas-generales/calificar";
      let params = new FormData();
      params.append('id_consulta',idConsulta);
      params.append('puntaje',puntaje);
      params.append('tipo',tipo);

      await this.$API
        .post({
          url: url,
          data: params
        }).then(() => {
          this.loadConsultas();
          this.titulo = "";
          this.descripcion = "";
          this.files = [];
        });  
    },
    remove (index) {
      this.files.splice(index, 1)
    },

    printConsole(data){
      // alert(JSON.stringify())
      // debugger;
      // console.log(data);
      this.respuestaAcreditacion = data.ConsultaAcreditacionRespuesta.respuesta
    },
    
    async addConsulta() {
      if(this.titulo.trim() == "" || this.descripcion.trim() == ""){
        alert('Escribe el titulo y descripción de tu consulta')
        return;
      }
      var formData = new FormData();
      formData.append('titulo',this.titulo);
      formData.append('descripcion',this.descripcion);
      formData.append('cantidadImagen',this.files.length);

      console.log(this.$refs)
      let i = 0;
      for (let file of this.files) {
          formData.append(`imagen_${i}`, file, file.name);
          i++;
      }
      console.log(formData);
      
      let url = "consultas-generales/store";
      await this.$API
        .post({
          url: url,
          data: formData
        }).then(() => {
          this.loadConsultas();
          this.titulo = "";
          this.descripcion = "";
          this.files = [];
        });  
    },
    async loadConsultas() {
      let url = "consultas-generales";
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.consultas = res;
          for (let index = 0; index < this.consultas.length; index++) {
            this.dialog = [];
            this.dialog[index] = false;
            this.dialog_desc = [];
            this.dialog_desc[index] = false;
          }
        });
    }
  },
  async loadConsultasAcreditacion() {
      let url = "consultas-acreditacion";
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.consultasAcreditacion = res;
          for (let index = 0; index < this.consultasAcreditacion.length; index++) {
            this.dialog_acred = [];
            this.dialog_acred[index] = false;
          }
        });
  },

  mounted() {
    this.$API
      .get({
        url: "consultas-generales"
      }).then((res) => {
        this.consultas = res;
      });

    this.$API
      .get({
        url: "consultas-acreditacion"
      }).then((res) => {
        this.consultasAcreditacion = res;
      });
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@700;900&display=swap");

.prism-elite-app {
  font-family: "Inter", sans-serif !important;
  background: radial-gradient(circle at 0% 0%, #f1f5f9 0%, #ffffff 100%);
  min-height: 100vh;
}

h1, h2, h3, .prism-heading, .text-overline {
  font-family: "Outfit", sans-serif !important;
  letter-spacing: -0.5px;
}

.main-container-glass {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(20px);
}

.prism-top-bar { background: transparent; }
.prism-divider { border-color: rgba(0,0,0,0.05) !important; }

/* Elite Cards */
.glass-card-heavy {
  background: white;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(0,0,0,0.05) !important;
}

.glass-card-interactive {
  background: white;
  border: 1px solid #f1f5f9 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.glass-card-interactive:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px -15px rgba(0, 0, 0, 0.1) !important;
}

.glass-card-light {
   background: rgba(255, 255, 255, 0.5) !important;
   border: 1px solid rgba(226, 232, 240, 0.8) !important;
}

/* Elite Form Inputs */
.elite-input ::v-deep fieldset,
.elite-textarea ::v-deep fieldset {
  border-color: rgba(0,0,0,0.08) !important;
  transition: border-color 0.3s;
}
.elite-input:hover ::v-deep fieldset,
.elite-textarea:hover ::v-deep fieldset {
  border-color: rgba(0,0,0,0.15) !important;
}
.elite-input.v-input--is-focused ::v-deep fieldset,
.elite-textarea.v-input--is-focused ::v-deep fieldset {
  border-color: #1a237e !important;
  border-width: 2px;
}

.elite-input ::v-deep input,
.elite-textarea ::v-deep textarea {
  font-weight: 500;
  color: #1e293b !important;
}

/* Icon Box */
.elite-icon-box {
  width: 56px;
  height: 56px;
  background: #f1f5f9;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Response Box */
.elite-response-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.elite-response-box.accred {
  background: #f0fdf4;
  border-color: #dcfce7;
}

.bg-slate-50 {
  background-color: #f8fafc;
}
.border-s {
  border-left: 4px solid #1a237e;
}
.border-accent {
  border-left: 4px solid #10b981;
}

.letter-spaced {
  letter-spacing: 1px !important;
}

.uppercase { text-transform: uppercase; }
.text-tiny { font-size: 0.75rem !important; }

.border-top {
  border-top: 1px solid #e2e8f0;
}

.consultas-viewport {
  max-height: 800px;
  overflow-y: auto;
  padding-right: 10px;
}
.consultas-viewport::-webkit-scrollbar {
  width: 6px;
}
.consultas-viewport::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 10px;
}

@media (min-width: 1264px) {
  .sticky-card {
    position: sticky;
    top: 20px;
  }
}
</style>





